import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import logoAssets from 'assets/assets.js';
import {logout} from 'actions/login';

import Faq from 'components/Faq';
import Login from 'components/Login';
import Coverage from 'components/Coverage';
import Footer from 'components/Footer';
import Header from 'components/Header';
import {RedirectModal, LoginModal} from 'components/Modals';

import './styles.scss';

const localStorageBoxedIsiExpanded = localStorage.getItem('boxedIsi-expanded');

export class PalPage extends Component {
  constructor(props) {
    super(props);

    const {settings} = props;

    const isExpandedInitialState = localStorageBoxedIsiExpanded !== null ?
      localStorageBoxedIsiExpanded === 'true' : settings.isi.boxedIsi.initializeExpanded;

    this.state = {
      showLoginModal: false,
      showRedirectModal: false,
      authenticated: false,
      isIsiTrayExpanded: isExpandedInitialState
    };

    this._modalHandler = this._modalHandler.bind(this);
  }

  updateIsiTrayExpanded = (value) => {
    localStorage.setItem('boxedIsi-expanded', value);
    this.setState((prevState) => ({
      ...prevState,
      isIsiTrayExpanded: value,
    }));
  }

  toggleExpandBoxedIsi = () => {
    this.updateIsiTrayExpanded(!this.state.isIsiTrayExpanded);
  }

  _modalHandler(type) {
    switch (type) {
      case 'hideLogin':
        this.setState({showLoginModal: false});
        break;

      case 'redirect':
        this.setState({showLoginModal: false, showRedirectModal: true});
        break;

      case 'logout':
        this.props.dispatchLogout();
        this.props.history.push('/');
        break;

      case 'exit':
        window.location.assign(this.props.settings.page.redirectLink);
        break;

      default:
        break;
    }
  }

  componentDidMount() {
    // Delaying modal display so Aphrodite can apply styles first, avoiding style flicker
    const {location, settings} = this.props;

    const showLoginModal = settings.loginModal.disabled
      ? false
      : (settings.authenticate ? (location.pathname === '/login' ? true : false) : true);

    setTimeout(() => {
      this.setState({showLoginModal});
    }, 5);
  }

  render() {
    const {
      location,
      authenticated,
      settings,
      styleSheet,
    } = this.props;

    const {showLoginModal, showRedirectModal, isIsiTrayExpanded} = this.state;

    const currentRoute = location.pathname;

    if (authenticated && currentRoute === '/login') {
      // Remove Auth token from URL.
      const urlParams = new URLSearchParams(this.props.location.search);
      urlParams.delete('token');

      return (<Redirect to={{
        pathname: '/',
        search: urlParams.toString(),
        state: {from: this.props.location}}}
      />);
    }

    return (
      <div>
        <LoginModal
          settings={settings}
          styleSheet={styleSheet}
          showLoginModal={showLoginModal}
          handleHide={() => this._modalHandler('hideLogin')}
          handleRedirect={() => this._modalHandler('redirect')}
        />
        {showRedirectModal && <RedirectModal
          settings={settings}
          styleSheet={styleSheet}
          showRedirectModal={showRedirectModal}
          handleExit={() => this._modalHandler('exit')}
        />}

        <Header
          logoAssets={logoAssets}
          settings={settings}
          styleSheet={styleSheet}
          authenticated={authenticated}
          handleLogout={() => this._modalHandler('logout')}
          expandBoxedIsi={() => this.updateIsiTrayExpanded(true)}
        />

        {currentRoute === '/login' && <Login styleSheet={styleSheet}/>}
        {currentRoute === '/faq' && <Faq styleSheet={styleSheet}/>}
        {currentRoute === '/' && <Coverage styleSheet={styleSheet}/>}

        <Footer
          settings={settings}
          styleSheet={styleSheet}
          logoAssets={logoAssets}
          toggleExpandBoxedIsi={this.toggleExpandBoxedIsi}
          isBoxedIsiExpanded={isIsiTrayExpanded}
        />
      </div>
    );
  }
}

PalPage.propTypes = {
  authenticated: PropTypes.bool,
  history: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
  dispatchLogout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {login, settings} = state;

  return {
    authenticated: login.get('authenticated'),
    settings: settings.get('settings').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchLogout: () => dispatch(logout()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PalPage));